
  import ScreenSize from '@/mixins/ScreenSize';
  import OrganizationTopList from '@/mixins/OrganizationTopList';
  export default {
    name: 'SectionOrganizationTopList',
    mixins: [OrganizationTopList, ScreenSize],
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
  };
